import { MetaData, FindCarNumberPage } from '@/components'
import { initializeStore } from '@/store'
import { getAreaInfoById, fetchAreaInfo } from '@/store/slices/stagesSlice/stagesSlice'
import { NextPage } from 'next'

const NextFindCarNumberPage: NextPage<{ areaId: string }> = ({ areaId }) => {
  return (
    <>
      <MetaData />
      <FindCarNumberPage areaId={areaId} />
    </>
  )
}

NextFindCarNumberPage.getInitialProps = async ({ query }) => {
  const areaId: string = query.areaId as string
  const reduxStore = initializeStore()
  const { dispatch, getState } = reduxStore

  const response = getAreaInfoById(getState(), areaId)
  if (!response.data) {
    await dispatch(fetchAreaInfo({ id: areaId }))
  }

  return {
    initialReduxState: reduxStore.getState(),
    areaId,
    headerLayout: 'back',
  }
}

export default NextFindCarNumberPage
